import { render, staticRenderFns } from "./kick.vue?vue&type=template&id=4364babe&scoped=true&lang=html&"
import script from "./kick.vue?vue&type=script&lang=js&"
export * from "./kick.vue?vue&type=script&lang=js&"
import style0 from "./kick.vue?vue&type=style&index=0&id=4364babe&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4364babe",
  null
  
)

component.options.__file = "kick.vue"
export default component.exports